// extracted by mini-css-extract-plugin
export default {"content":"AccessToCommunity_content__FngvI","subtitle":"AccessToCommunity_subtitle__KJBhn","bottomBorderDiv":"AccessToCommunity_bottomBorderDiv__lpzOY"};